import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Router } from '@angular/router';
import { EnvironmentsService } from './enviroment.service';
import { WebkitService } from '../services/webkit.service';
import { ReplaySubject, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class DeeplinkService {
  baseUrl: any;
  readonly emitDataSubject = new Subject<any>();
  constructor(
    readonly http: HttpClient,
    readonly env: EnvironmentsService,
    readonly router: Router,
    readonly webkitService: WebkitService
  ) {
    this.baseUrl = env.apiUrl;
  }
  emitData(data: any): any {
    this.emitDataSubject.next(data);
  }
  getLink(data: any): any {
    const headers = this.webkitService.returnHeader();
    return this.http.post(
      this.env.apiUrl + '/hi-ecom-seller-api/v1/web/get-link',
      data,
      { headers }
    );
  }
  handleLink(data: any): any {
    return this.http.get<any>(
      this.env.apiUrl + '/hi-ecom-seller-v2-api/v1/shortlink/handle-redirect?' + data
    );
    // window.location.href = this.env.apiUrl + '/hi-ecom-seller-v2-api/v1/shortlink/handle-redirect?' + data;
    // window.open(this.env.apiUrl + '/hi-ecom-seller-v2-api/v1/shortlink/handle-redirect?' + data);
  }
  decodeLink(data: any): any {
    const headers = this.webkitService.returnHeader();
    return this.http.post(
      this.env.apiUrl + '/hi-ecom-seller-api/v1/web/decode-link',
      data,
      { headers }
    );
  }
  getToken(token: string): any {
    if (token && token !== '') {
      const arr = new ReplaySubject(1);
      const headers = { TOKEN: token };
      sessionStorage.setItem('app_token', token);
      sessionStorage.setItem('webkit_token', '');
      this.http
        .post<any>(this.baseUrl + '/hi-auth2-api/v1/web/auth', {}, { headers })
        .subscribe(
          (res) => {
            if (res && res.status === 1) {
              const accessToken = res.token;
              sessionStorage.setItem('webkit_token', accessToken);
              sessionStorage.setItem('refresh_token', res.refresh_token);
              arr.next('ok');
            } else {
              arr.next('not_ok');
            }
          },
          (error) => {
            arr.next('not_ok');
            // this.goHome();
          }
        );
      return arr;
    } else {
      // this.goHome();
    }
  }
  getWebkitToken(): any {
    return sessionStorage.getItem('webkit_token');
  }
  getLinkInApp(data: any): any {
    if (sessionStorage.getItem('webkit_token')) {
      const headers = { TOKEN: this.getWebkitToken() };
      return this.http.post(
        this.env.apiUrl +
          '/hi-ecom-seller-api/v1/public/webkit/deeplink/get-data',
        data,
        { headers }
      );
    }
  }
  callAppFunction(str: any): any {
    // @ts-ignore
    if (window.AndroidBridge) {
      // @ts-ignore
      window.AndroidBridge.callbackToApp(str);
      // @ts-ignore
    } else if (window.webkit && window.webkit.messageHandlers) {
      // @ts-ignore
      window.webkit.messageHandlers.callbackToApp.postMessage(str);
    }
  }
  callToken(): any {
    // @ts-ignore
    if (window.AndroidBridge) {
      // @ts-ignore
      window.AndroidBridge.callbackToApp('{"action" : "getToken"}');
      // @ts-ignore
    } else if (window.webkit && window.webkit.messageHandlers) {
      // @ts-ignore
      window.webkit.messageHandlers.callbackToApp.postMessage(
        '{"action" : "getToken"}'
      );
    }
  }
}
